import axios from "axios"

//api base url
export const apiClient = axios.create(
    {
        baseURL: 'https://medicover-api.onrender.com'
    }
)